import { AppArea, ExperimentConfig, ExperimentName } from '@/funnels/@types'

import web_autotest_female_funnel_check from './experiments/web_autotest_female_funnel_check'
import web_wheel_of_fortune_walking_female from './experiments/web_wheel_of_fortune_walking_female'
import web_wheel_of_fortune_activity_female from './experiments/web_wheel_of_fortune_activity_female'
import web_wheel_of_fortune_yoga_female from './experiments/web_wheel_of_fortune_yoga_female'
import web_wheel_of_fortune_male from './experiments/web_wheel_of_fortune_male'
import web_summary_checkpoints_walking from './experiments/web_summary_checkpoints_walking'
import web_summary_checkpoints_yoga from './experiments/web_summary_checkpoints_yoga'
import web_summary_checkpoints_tai_chi_male from './experiments/web_summary_checkpoints_tai_chi_male'
import web_ai_generated_female_funnel from './experiments/web_ai_generated_female_funnel'
import web_apple_pay_renaming from './experiments/web_apple_pay_renaming'
import web_ask_age_starting_screens from './experiments/web_ask_age_starting_screens'
import web_fallback_on_payment from './experiments/web_fallback_on_payment'
import web_en_countries_price_optimization from './experiments/web_en_countries_price_optimization'
import web_bulk_change_walking_female from './experiments/web_bulk_change_walking_female'
import web_pricing_on_pilates_funnel_with_sp from './experiments/web_pricing_on_pilates_funnel_with_sp'
import web_yoga_printable_guide_welcome from './experiments/web_yoga_printable_guide_welcome'
import web_walking_female_weight_loss_plan from './experiments/web_walking_female_weight_loss_plan'
import web_walking_to_lose_weight_gdn from './experiments/web_walking_to_lose_weight_gdn'
import web_walking_to_lose_weight_keyword from './experiments/web_walking_to_lose_weight_keyword'
import web_pricing_on_fasting_funnels_with_sp_nonus from './experiments/web_pricing_on_fasting_funnels_with_sp_nonus'
import web_walking_female_indoor from './experiments/web_walking_female_indoor'
import web_pricing_for_desktop from './experiments/web_pricing_for_desktop'
import web_welcome_for_search_fasting_schedule from './experiments/web_welcome_for_search_fasting_schedule'
import web_chair_yoga_challenge_landing from './experiments/web_chair_yoga_challenge_landing'
import web_welcome_for_search_fasting_lose_weight from './experiments/web_welcome_for_search_fasting_lose_weight'
import web_welcome_for_demgen_walking from './experiments/web_welcome_for_demgen_walking'
import web_yoga_female_scratch_card_before_the_paywall from './experiments/web_yoga_female_scratch_card_before_the_paywall'
import web_pilates_gamification_progress from './experiments/web_pilates_gamification_progress'
import web_fasting_fem_paywall_w_plan_benefits from './experiments/web_fasting_fem_paywall_w_plan_benefits'
import web_thai_chi_walking_fem_christmas_sale from './experiments/web_thai_chi_walking_fem_christmas_sale'
import web_tai_chi_walking_female_plan_benefits from './experiments/web_tai_chi_walking_female_plan_benefits'
import web_welcome_for_search_fasting_diet_keywords from './experiments/web_welcome_for_search_fasting_diet_keywords'
import web_chair_workouts_male_subtitles from './experiments/web_chair_workouts_male_subtitles'
import web_welcome_for_search_fasting_calculator from './experiments/web_welcome_for_search_fasting_calculator'
import web_pilates_plan_preview_before_paywall from './experiments/web_pilates_plan_preview_before_paywall'
import web_fasting_f_personalized_coupon from './experiments/web_fasting_f_personalized_coupon'
import web_data_input_screens_optimized from './experiments/web_data_input_screens_optimized'
import web_gamify_learning_within_the_funnel from './experiments/web_gamify_learning_within_the_funnel'
import web_tai_chi_al_risk_free_offer from './experiments/web_tai_chi_al_risk_free_offer'
import web_tai_chi_al_paywall_plan_benefits from './experiments/web_tai_chi_al_paywall_plan_benefits'
import web_tai_chi_tree_discount from './experiments/web_tai_chi_tree_discount'
import web_chair_workouts_male_sales_tax_exclusion_i2 from './experiments/web_chair_workouts_male_sales_tax_exclusion_i2'
import web_large_checkout_update from './experiments/web_large_checkout_update'
import web_fasting_fem_social_proof_on_first_and_paywall from './experiments/web_fasting_fem_social_proof_on_first_and_paywall'
import web_sp_monetization_female_fasting from './experiments/web_sp_monetization_female_fasting'
import web_paywall_with_social_proof from './experiments/web_paywall_with_social_proof'
import web_welcome_for_google_tai_chi_gs from './experiments/web_welcome_for_google_tai_chi_gs'
import web_welcome_for_google_tai_chi_walking_gs from './experiments/web_welcome_for_google_tai_chi_walking_gs'
import web_glp_upsell_fakedoor from './experiments/web_glp_upsell_fakedoor'
import web_welcome_for_applovin_tai_chi_walking from './experiments/web_welcome_for_applovin_tai_chi_walking'
import web_tai_chi_fem_v2_social_proof from './experiments/web_tai_chi_fem_v2_social_proof'
import web_pro_version_activity_funnels from './experiments/web_pro_version_activity_funnels'

const experimentsConfig: Partial<Record<AppArea, { [key: ExperimentName<string>]: ExperimentConfig[] }>> = {
	// fasting
	female: {
		web_autotest_female_funnel_check,
		web_fallback_on_payment,
		web_ai_generated_female_funnel,
		web_pricing_on_fasting_funnels_with_sp_nonus,
		web_pricing_for_desktop,
		web_fasting_fem_paywall_w_plan_benefits,
		web_fasting_fem_social_proof_on_first_and_paywall,
		web_fasting_f_personalized_coupon,
		web_large_checkout_update,
		web_data_input_screens_optimized,
		web_gamify_learning_within_the_funnel,
		web_sp_monetization_female_fasting,
		web_glp_upsell_fakedoor,
	},
	male: {
		web_wheel_of_fortune_male,
		web_en_countries_price_optimization,
		web_ask_age_starting_screens,
		web_pricing_on_fasting_funnels_with_sp_nonus,
	},
	main: {
		web_welcome_for_search_fasting_schedule,
		web_welcome_for_search_fasting_lose_weight,
		web_welcome_for_search_fasting_diet_keywords,
		web_welcome_for_search_fasting_calculator,
		web_fasting_fem_social_proof_on_first_and_paywall,
	},

	// yoga
	'activity-female-yoga': {
		web_apple_pay_renaming,
		web_wheel_of_fortune_yoga_female,
		web_summary_checkpoints_yoga,
		web_pricing_for_desktop,
		web_yoga_female_scratch_card_before_the_paywall,
		web_fallback_on_payment,
	},
	'activity-male-chair-workouts': {
		web_pricing_for_desktop,
		web_chair_workouts_male_subtitles,
		web_chair_workouts_male_sales_tax_exclusion_i2,
		web_paywall_with_social_proof,
	},
	'main-yoga': {
		web_yoga_printable_guide_welcome,
		web_chair_yoga_challenge_landing,
	},

	// walking
	'activity-female-walking': {
		web_apple_pay_renaming,
		web_wheel_of_fortune_walking_female,
		web_summary_checkpoints_walking,
		web_en_countries_price_optimization,
		web_walking_female_weight_loss_plan,
		web_ask_age_starting_screens,
		web_walking_female_indoor,
		web_bulk_change_walking_female,
		web_welcome_for_demgen_walking,
		web_fallback_on_payment,
		web_pro_version_activity_funnels,
		web_pricing_for_desktop,
	},
	'activity-male-walking': {
		web_ask_age_starting_screens,
	},
	'female-printable-walking': {},
	'main-walking': {
		web_walking_to_lose_weight_gdn,
		web_walking_to_lose_weight_keyword,
	},

	// pilates
	'activity-female-pilates': {
		web_pricing_on_pilates_funnel_with_sp,
		web_ask_age_starting_screens,
		web_pilates_gamification_progress,
		web_pilates_plan_preview_before_paywall,
	},
	'activity-female-boudoir-pilates-fwf': {},

	// activity
	'activity-female-v2': {
		web_wheel_of_fortune_activity_female,
		web_ask_age_starting_screens,
	},
	'activity-male': {},
	'main-activity': {},

	// tai-chi
	'activity-female-tai-chi': {},
	'activity-female-tai-chi-walking': {},
	'activity-female-tai-chi-walking-v2': {
		web_apple_pay_renaming,
		web_thai_chi_walking_fem_christmas_sale,
		web_tai_chi_walking_female_plan_benefits,
		web_fallback_on_payment,
		web_tai_chi_tree_discount,
		web_large_checkout_update,
		web_tai_chi_fem_v2_social_proof,
		web_pro_version_activity_funnels,
		web_pricing_for_desktop,
	},
	'activity-female-tai-chi-walking-pr': {},
	'activity-male-tai-chi-walking': {},
	'activity-male-tai-chi-yoga': {
		web_summary_checkpoints_tai_chi_male,
	},
	'activity-male-tai-chi-yoga-pr': {},
	'activity-male-chair-tai-chi-fwf': {},
	'main-tai-chi': {
		web_welcome_for_google_tai_chi_gs,
	},
	'main-tai-chi-walking': {
		web_welcome_for_google_tai_chi_walking_gs,
		web_tai_chi_fem_v2_social_proof,
	},

	// glp
	'female-glp': {},
	'glp-1': {},

	// calisthenics

	// japanese-walking
	'activity-female-walking-japanese': {},
	'activity-female-walking-japanese-v2': {},

	// asian-pilates

	// military

	// water-fasting
	'female-water-fasting': {},

	// high-protein

	// diets
	'female-cortisol-diet': {},
	'female-menopause-diet': {},
	'female-mediterranean-diet': {},
	'female-anti-inflammatory-diet': {},
	'female-ramadan-fwf': {},

	// applovin
	'activity-female-yoga-al': {},
	'activity-female-walking-al': {},
	'activity-male-tai-chi-walking-al': {},
	'female-al': {},
	'activity-female-tai-chi-walking-al': {},
	'activity-female-tai-chi-walking-v2-al': {
		web_tai_chi_al_risk_free_offer,
		web_tai_chi_al_paywall_plan_benefits,
		web_large_checkout_update,
		web_pricing_for_desktop,
		web_welcome_for_applovin_tai_chi_walking,
	},

	// other
}

export default experimentsConfig
